import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import _ from 'lodash';
import { useCallback } from 'react';
import { propFunc, propShape } from '../../../../../helpers/custom-prop-types';
import { validatePerformance, validateSolveIssue, } from '../../../../../validate/solution';
import OptionFields from '../../../../Ui/Professional/Solution/Fields/Custom/OptionFields';
import SolutionFieldArray from '../../../../Ui/Professional/Solution/Fields/SolutionFieldArray';
import SolutionTextArea from '../../../../Ui/Professional/Solution/Fields/SolutionTextArea';
import NextNav from '../../../../Ui/Professional/Solution/Parts/NextNav';
import PrevNav from '../../../../Ui/Professional/Solution/Parts/PrevNav';
const FormSolutionStep2 = (props) => {
    const { formFields, goBackStep, onClickNext, style } = props;
    const onClick = useCallback((step) => {
        const names = ['solveIssue', 'performance'];
        const options = _.get(formFields, 'values.options') || [];
        for (let i = 0; i < options.length; i += 1) {
            names.push(`options[${i}].name`, `options[${i}].price`);
        }
        onClickNext(step, names);
    }, [formFields, onClickNext]);
    return (_jsxs("div", Object.assign({ style: style }, { children: [_jsxs("div", Object.assign({ className: 'l-container-9' }, { children: [_jsx(SolutionTextArea, { isRequired: true, label: 'プロジェクト事例の対象者（100字程度）', name: 'solveIssue', placeholder: [
                            '業種や部門など、具体的に記載することでユーザーが対象者だと認識しやすくなります',
                            '例）Webマーケティング企画部の方、製造業の直接材調達部門の方',
                        ].join('\n'), tip: '部門、業種、業務など具体的に記載すると注目されやすくなります。', type: 'text', validate: validateSolveIssue }), _jsx(SolutionTextArea, { isRequired: true, label: 'プロジェクト事例の実績（100字程度）', name: 'performance', placeholder: [
                            'プロジェクト事例の実施回数や大企業での利用実績、有力メンバーなどを記載してください',
                            'また、関連領域でのメディア掲載実績や著書などがあれば記載してください',
                            '例）大企業の経営企画部門を中心に20回以上の実績があります',
                        ].join('\n'), validate: validatePerformance }), _jsx(SolutionFieldArray, { component: OptionFields, label: 'オプションを記入してください', name: 'options' })] })), _jsx("div", Object.assign({ className: 'l-container-9' }, { children: _jsxs("div", Object.assign({ className: 'contents-footer-nav step-nav' }, { children: [_jsx(PrevNav, { goBackStep: goBackStep, step: 2 }), _jsx(NextNav, { disabled: false, goNextStep: onClick, step: 2 })] })) }))] })));
};
FormSolutionStep2.propTypes = {
    formFields: propShape().isRequired,
    goBackStep: propFunc().isRequired,
    onClickNext: propFunc().isRequired,
    style: propShape().isRequired,
};
export default FormSolutionStep2;
